import React from 'react';
import Hero from '../components/Hero';
import CameraWindow from '../components/CameraWindow';
import Lessons from '../components/Lessons';

const Home = ({ onFullscreenChange }) => {
  return (
    <>
      <Hero />
      <CameraWindow onFullscreenChange={onFullscreenChange} />
      <Lessons />
    </>
  );
};

export default Home;
